<template>
  <div
    v-if="visible"
    class="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 px-4 backdrop-blur-sm dark:bg-black/70"
    role="dialog"
    aria-modal="true"
    aria-labelledby="consent-title"
  >
    <div class="w-full max-w-md rounded-2xl border border-zinc-200 bg-base p-6 shadow-2xl dark:border-white/10 dark:bg-base-dark">
      <h2 id="consent-title" class="text-lg font-semibold text-zinc-900 dark:text-zinc-50">
        Before you start
      </h2>
      <p class="mt-3 text-sm leading-relaxed text-zinc-600 dark:text-zinc-300">
        To use YouStory, please accept our
        <router-link to="/privacy-policy" class="font-medium text-violet-600 underline dark:text-violet-400">Privacy Policy</router-link>.
      </p>
      <p class="mt-3 text-sm leading-relaxed text-zinc-600 dark:text-zinc-300">
        You can also help us improve the app by sharing usage statistics, such as
        which steps you use. They never include your requests, stories or names.
        You can change this any time on the Privacy Policy page.
      </p>
      <div class="mt-6 flex flex-col gap-3">
        <button
          @click="accept(true)"
          class="rounded-2xl bg-gradient-to-r from-violet-600 to-indigo-500 px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-violet-500/25 transition hover:shadow-violet-500/40"
        >
          Accept and share usage statistics
        </button>
        <button
          @click="accept(false)"
          class="rounded-2xl border border-zinc-200 px-5 py-2.5 text-sm font-medium text-zinc-600 transition hover:border-zinc-300 hover:text-zinc-900 dark:border-white/10 dark:text-zinc-300 dark:hover:border-white/20 dark:hover:text-zinc-50"
        >
          Accept without statistics
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { getConsent, saveConsent } from '@/analytics';

const route = useRoute();
const accepted = ref(!!getConsent());

// The legal pages stay readable before accepting.
const visible = computed(
  () =>
    !accepted.value &&
    !['PrivacyPolicy', 'DataDeletion'].includes(route.name)
);

function accept(stats) {
  saveConsent(stats);
  accepted.value = true;
}
</script>
